import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  constructor(
    private AUTH: AuthService,
    private REF: MatDialogRef<LoginComponent>
  ) {}

  login: FormGroup;

  ngOnInit(): void {
    this.login = new FormGroup({
      email: new FormControl(''),
      password: new FormControl(''),
    });
  }

  loginFire() {
    this.AUTH.emailSignin(
      this.login.value.email,
      this.login.value.password
    ).then(() => this.REF.close());
  }
}
